import { useScreenSize } from "../../hooks/useScreenSize";


export default function AzureADLogin() {
  const {isMobile} = useScreenSize();
  return (
    <div className="header-container flex-row-align txt-color  vh-100">
      <div className={`${isMobile ? "flex-colomn" : "flex-row space-evenly align-items"} w-100 ptb-1"`} >
        <div>
          <h1 className="text-lg font-semibold">Decoratie Degezelle</h1>
          <p>Welcome to your adminpanel 🎉</p>
        </div>
        <div className={`logout flex-row-align ${isMobile ? 'justify-end' : ''}`}>
          <a className="btn " href="/.auth/login/aad">
            log in
          </a>
        </div>
      </div>
    </div>
  );
}
